import BaseErrorBoundaryWithRenderer from "./BaseErrorBoundaryWithRenderer";
import AuthenticationManager from "../Authentication/AuthenticationManager";
import withAlert from "../Alerts/withAlert";

class MainErrorBoundary extends BaseErrorBoundaryWithRenderer {
  renderErrorComponent() {
    if (this.needsToSignIn) {
      return <AuthenticationManager onClose={this.handleModalClosed} />;
    } else {
      return super.renderErrorComponent();
    }
  }
}

export default withAlert(MainErrorBoundary);
